import { render, staticRenderFns } from "./ShortlistModal.vue?vue&type=template&id=1d5cd3a0&"
import script from "./ShortlistModal.vue?vue&type=script&lang=js&"
export * from "./ShortlistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports